export const intersectArrayList = (list: any[][]) => {
    if (!list || list.length === 0)
        return [];
    let result = list.reduce((a, b) => b.filter(Set.prototype.has, new Set(a)));
    return result;
}